import { useContext, useEffect, useRef, useState } from "react";
import { getToken } from "../services/auth";
import CountDeliveryAndTable from "../services/countDeliveryAndTable";
import { SocketDeliveryContext } from "../contexts/socketDelivery";

export const useCountTable = () => {
    const [countTable, setCountTable] = useState(0);
    const {emitSocket, listenSocket} = useContext(SocketDeliveryContext)
    const guardarListenSocket = useRef(null)
    
    useEffect(()=> {
        if(window.location.pathname !== '/'){
            verifyUrl();
            guardarListenSocket.current = listenSocket('countTable', (data) => {
                setCountTable(data?.data?.count)
            })
    
        }
        
        return () => guardarListenSocket?.current?.()
    }, [getToken('CNPJ')]);

    const getCountTable = async () => {
        try {
            const cnpj = getToken('CNPJ');
            const service = new CountDeliveryAndTable();
            const result = await service.getCountTable({
                cnpj
            })
            
            if (result.success) {
                emitSocket('countTable', {
                    id: getToken('CNPJ'),
                    count: result.data[0].qtd
                })
            }
        } catch (error) {
            console.log(error)
        }
    }

    const verifyUrl = () => { getCountTable();}


    return {countTable, setCountTable, getCountTable}
}